import {
  Record,
  String as RTString,
  Array as RTArray,
  Undefined,
  Null,
  Static
} from 'runtypes';
import { DeepPartial } from 'utility-types';
import { CoTrustee, Trust } from '../../additional-customers';
import {
  AccountTransferDetails,
  BankAccountReference,
  BankFailure
} from '../../bank-acount';
import { Investment } from '../../investment';
import { PrimaryCustomer } from '../../customer';

export const TrustApplication = Record({
  trustee: PrimaryCustomer,
  coTrustees: RTArray(CoTrustee)
    .Or(Undefined)
    .Or(Null),
  trust: Trust,
  bankInformationReference: BankAccountReference.Or(Undefined).Or(Null),
  bankFailureInformation: RTArray(BankFailure)
    .Or(Undefined)
    .Or(Null),
  accountTransferDetails: RTArray(AccountTransferDetails)
    .Or(Undefined)
    .Or(Null),
  newInvestments: RTArray(Investment),
  investmentMethod: RTString,
  fundingMethodType: RTString,
  profileApplicationID: RTString,
  applicationStatus: RTString.Or(Undefined),
  termsIDs: RTArray(RTString),
  deviceToken: RTString
});

export type StaticTrustApplication = Static<typeof TrustApplication>;
export type OptionalTrustApplication = DeepPartial<StaticTrustApplication>;
